// src/components/comment/CommentsDrawer.tsx
import React, { useEffect, useState } from 'react';
import { Drawer, Spin, message, Input, Button } from 'antd';
import { TComment } from '../../../models/project/project';
import { useProjectApi } from '../../../api/projects/projects';
import { useTilmiAuth } from '../../../hooks/useTilmiAuth';
import CommentItem from '../../comment/CommentItem';
const { TextArea } = Input;

interface CommentsDrawerProps {
  projectId: number;
  open: boolean;
  onClose: () => void;
  handleAddComment: () => void;
}

const CommentsDrawer: React.FC<CommentsDrawerProps> = ({
  projectId,
  open,
  onClose,
  handleAddComment,
}) => {
  const { getFullName } = useTilmiAuth()
  const { getCommentsByProjectId, createComment } = useProjectApi();
  const [comments, setComments] = useState<TComment[]>([]);
  const [loading, setLoading] = useState(false);
  const [newComment, setNewComment] = useState('');

  /** Charge les commentaires à chaque ouverture */
  useEffect(() => {
    if (!open) return;
    setLoading(true);
    getCommentsByProjectId(projectId)
      .then(res => {
        const list = res.data ?? [];
        setComments(list);
      })
      .catch(err => {
        message.error("Echec de récupérer les commentaires.");
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, projectId]);

  const handleSend = () => {
    if (!newComment.trim()) {
      message.warning("Veuillez entrer un commentaire.");
      return;
    }
    const payload: TComment = {
      id: 0,
      project_id: projectId,
      userapp_id: 0,        // TODO : id utilisateur auth
      content: newComment,
      author_name: getFullName() ?? ''
    };
    createComment(payload)
      .then(res => {
        const created = res.data;
        const list = [...comments, created];
        setComments(list);
        handleAddComment();
        setNewComment('');
      })
      .catch(err => {
        message.error("Echec d'ajouter le commentaire.");
      });
  };

  return (
    <Drawer
      title={`Commentaires (${comments.length})`}
      placement="right"
      width={600}
      open={open}
      onClose={onClose}
      styles={{ body: { display: 'flex', flexDirection: 'column', padding: 0 } }}
    >
      {loading ? (
        <Spin style={{ margin: 'auto' }} />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div style={{ flex: 1, overflowY: 'auto', padding: 16 }}>
            {comments.length ? (
              comments.map((c, i) => (
                <React.Fragment key={c.id}>
                  <CommentItem comment={c} />
                  {i !== comments.length - 1 && (
                    <hr style={{ border: 'none', borderTop: '1px solid #e8e8e8', margin: '16px 0' }} />
                  )}
                </React.Fragment>
              ))
            ) : (
              <div style={{ textAlign: 'center', color: '#999' }}>Aucun commentaire.</div>
            )}
          </div>
          <div style={{ padding: 16, borderTop: '1px solid #f0f0f0' }}>
            <TextArea
              rows={3}
              placeholder="Écrivez votre commentaire…"
              value={newComment}
              onChange={e => setNewComment(e.target.value)}
            />
            <Button type="primary" block style={{ marginTop: 8 }} onClick={handleSend}>
              Envoyer
            </Button>
          </div>
        </div>
      )}
    </Drawer>
  );
};

export default CommentsDrawer;
